"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamStateSubject = void 0;
const rxjs_1 = require("rxjs");
const stream_utils_1 = require("./utils/stream-utils");
class StreamStateSubject extends rxjs_1.BehaviorSubject {
    next(next) {
        const current = this.value;
        if (!stream_utils_1.StreamUtils.statesEqual(current, next)) {
            super.next(next);
        }
    }
}
exports.StreamStateSubject = StreamStateSubject;
